export const MODULE_TYPES = {
    SPOC: {key: 'SPOC', messageId: 'types.module.spoc', hasDataTable: false},
    BIRTHDAYS: {key: 'BIRTHDAYS', messageId: 'types.module.birthdays', hasDataTable: true},
    GROCERIES: {key: 'GROCERIES', messageId: 'types.module.groceries', hasDataTable: true},
    MESSAGES: {key: 'MESSAGES', messageId: 'types.module.messages', hasDataTable: true},
    POLISH: {key: 'POLISH', messageId: 'types.module.polish', hasDataTable: false},
    ROOMS: {key: 'ROOMS', messageId: 'types.module.rooms', hasDataTable: false},
    VIDEOS: {key: 'VIDEOS', messageId: 'types.module.videos', hasDataTable: true}
};

export const MODULE_TYPES_WITH_DATATABLE = Object.keys(MODULE_TYPES).reduce((acc, key) => {
    return MODULE_TYPES[key].hasDataTable ? [...acc, key] : acc;
}, []);

export const MODULE_TYPE_OPTIONS = Object.keys(MODULE_TYPES).map(key => MODULE_TYPES[key]);


// WEBPACK FOOTER //
// ./src/constants/moduleTypes.js